<template>
  <div class="card shadow-bg">
    <div class="card-header">
      <h3 class="mb-0">Statistics</h3>
    </div>
    <div class="card-body">
      <pie-chart v-if="show" :chart-data="chartData" />
    </div>
  </div>
</template>

<script>
import * as chartConfigs from '@/components/Charts/config'
import PieChart from '@/components/Charts/PieChart'

export default {
  name: 'ReferralChart',
  components: { PieChart },
  data() {
    return {
      show: false,
      chartData: {
        datasets: [
          {
            label: 'Performance',
            data: [10, 10]
          }
        ],
        labels: ['May', 'Jun']
      }
    }
  },
  props: {
    referrals: Array
  },
  methods: {
    capitalize(string) {
      if (string) {
        const firstChar = string.slice(0, 1)

        return firstChar.toUpperCase() + string.slice(1) + 's'
      }
      return ''
    }
  },
  beforeMount() {
    const backgroundColor = [
      '#001f3f',
      '#0074D9',
      '#7FDBFF',
      '#39CCCC',
      '#3D9970'
    ]

    const events = [...new Set(this.referrals.map((i) => i.event_type))]
    this.chartData.labels = []

    const data = []
    events.forEach((event) => {
      this.chartData.labels.push(this.capitalize(event))
      data.push(this.referrals.filter((i) => i.event_type === event).length)
    })

    this.chartData.datasets = [
      {
        label: 'Referrals',
        backgroundColor,
        data
      }
    ]

    this.show = true
  }
}
</script>

<style scoped></style>
